export function validateImageSize(file) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      if (img.width >= 250 && img.height >= 250) {
        resolve()
      } else {
        reject(new Error('error'))
      }
    }
    img.onerror = () => {
      reject(new Error('error'))
    }
    img.src = URL.createObjectURL(file)
  })
}
